module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-11-9a512778f642061f41f1c3b3c39023d5.svg";